import * as yup from "yup";
const phoneRegExp = /^09(0[0-9]|1[0-9]|3[0-9]|2[0-9])-?[0-9]{3}-?[0-9]{4}$/;
const userRegex = /^[a-zA-Z]\w+$/;
export const estateInfoSchema = yup.object().shape({
  ExZoneId: yup.number().required("این گزینه نمی تواند خالی باشد"),
  ExCategoryId: yup.number().required("این گزینه نمی تواند خالی باشد"),
  lat: yup.number().required("موقعیت ملک  را روی نقشه انتخاب کنید"),
  lng: yup.number().required("موقعیت ملک  را روی نقشه انتخاب کنید"),
  address: yup.string().required("آدرس نمی تواند خالی باشد"),
});

export const ownerInfoSchema = yup.object().shape({
  name: yup.string().required("نام نمی تواند خالی باشد"),
  tel: yup
    .string()
    .matches(phoneRegExp, "شماره تلفن معتبر نیست")
    .length(11, "شماره تلفن باید 11 رقم باشد")
    .required("شماره تلفن نمی تواند خالی باشد"),
  nationalId: yup.string().length(10, "کدملی باید 10 رقم باشد"),
});

export const estateSchema = yup.object().shape({
  ExCategoryText: yup.string(),
  ExDocumentText: yup.string(),
  ExZoneId: yup.string().required("منطقه نمی تواند خالی باشد"),
  ExCategoryId: yup.string().required("نوع ملک نمی تواند خالی باشد"),
  ExDocumentId: yup.string().required("نوع سند نمی تواند خالی باشد"),
  addressInfo: yup.object().shape({
    postCode: yup.string().required("کد پستی نمی تواند خالی باشد"),
    plaque: yup.string().required("پلاک نمی تواند خالی باشد"),
    address: yup.string().required("آدرس نمی تواند خالی باشد"),
  }),
});

export const desSchema = yup.object().shape({
  attributes: yup.object().shape({
    title: yup.string().required("عنوان پستی نمی تواند خالی باشد"),
    phi: yup.string().required("قیمت نمی تواند خالی باشد"),
    QTY: yup.string().required("متراژ نمی تواند خالی باشد"),
  }),
});

export const newRequestSchema = yup.object().shape({
  zone: yup.number().required("این گزینه نمی تواند خالی باشد"),
  category: yup.number().required("این گزینه نمی تواند خالی باشد"),
  timeId: yup.number().required("زمان کارشناسی نمی تواند خالی باشد"),
  address: yup.string().required("آدرس نمی تواند خالی باشد"),
  name: yup.string().required("نام نمی تواند خالی باشد"),
  phone: yup.string().required("تلفن نمی تواند خالی باشد"),
});

export const addExpertSchema = yup.object().shape({
  ExZoneId: yup.number().required("این گزینه نمی تواند خالی باشد"),
  agencyAddress: yup.string().required("آدرس نمی تواند خالی باشد"),
  agencyName: yup.string().required("نام دفتر نمی تواند خالی باشد"),
  agencyTel: yup.string().required("شماره تلفن نمی تواند خالی باشد"),
  name: yup.string().required("نام نمی تواند خالی باشد"),
  userName: yup.string().required("نام کاربری نمی تواند خالی باشد"),
  mobile: yup.string().required("تلفن نمی تواند خالی باشد"),
  type: yup.string().required("نوع کارشناس را انتخاب کنید"),
  password: yup.string().required("کلمه عبور نمی تواند خالی باشد"),
  reqPassword: yup.string().required("تکرار کلمه عبور نمی تواند خالی باشد"),
  sheba: yup.string().required("شماره شبا عبور نمی تواند خالی باشد"),
  pic: yup.string().required("این تصویر نمی تواند خالی باشد"),
  parvane: yup.string().required("این تصویر نمی تواند خالی باشد"),
  stamp: yup.string().required("این تصویر نمی تواند خالی باشد"),
});

export const addRealEstateSchema = yup.object().shape({
  name: yup.string().required("نام نمی تواند خالی باشد"),
  nationalId:  yup.string().required("کد ملی نمی تواند خالی باشد"),
  mobile: yup.string().required("تلفن نمی تواند خالی باشد"),
  userName: yup.string().required("نام کاربری نمی تواند خالی باشد"),
  password: yup.string().required("کلمه عبور نمی تواند خالی باشد"),
  pic: yup.string().required("این تصویر نمی تواند خالی باشد"),
  agencyName: yup.string().required("نام دفتر نمی تواند خالی باشد"),
  agencyAddress: yup.string().required("آدرس نمی تواند خالی باشد"),
  logo:  yup.string().required("این تصویر نمی تواند خالی باشد"),
  tel:  yup.string().required("شماره تلفن نمی تواند خالی باشد"),
  ExZoneId: yup.number().required("این گزینه نمی تواند خالی باشد"),
  pic2:  yup.string().required("این تصویر نمی تواند خالی باشد"),
});
